import { useContent } from "../../../../../contexts/contentContext/contentContext";
import useInbox from "hooks/useInbox.ts";
import { usePicker } from "../../../../../contexts/pickerContext/pickerContext";
import useQueryParams from "../../../../../hooks/useQueryParams";
import { ButtonA } from "../../../../Elements/Button/Button";
import useAdditionalSearchInfo from "./hooks/useAdditionalSearchInfo";

import styles from "./styles.module.scss";

const AdditionalSearchInfo = () => {
  const { getTextByKey } = useContent();
  const { getQueryParam } = useQueryParams();
  const { getIsFetchingPickerData } = usePicker();
  const { getIsFetching } = useInbox();
  const { additionalSearchQuantity } = useAdditionalSearchInfo();

  const additionalResultsName =
    getQueryParam("t") === "picker" ? "mail" : "picker";
  const additionalResultsPage =
    getQueryParam("t") === "picker"
      ? `inbox?t=all&q=${getQueryParam("q")}`
      : `inbox?t=picker&q=${getQueryParam("q")}`;

  return getIsFetchingPickerData() ||
    getIsFetching() ||
    !additionalSearchQuantity ? null : (
    <div className={styles.additionalSearchWrapper}>
      <span>
        {getTextByKey(
          `additional-search-results-${additionalResultsName}`
        ).replace("%value%", additionalSearchQuantity)}
      </span>
      {/*@ts-ignore*/}
      <ButtonA page={additionalResultsPage} blank buttonClass={styles.showMoreButton}>
        {getTextByKey('show-more')}
      </ButtonA>
    </div>
  );
};

export default AdditionalSearchInfo;
